import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import PatientListsIcon from 'svg/PatientListsIcon';

export default function DenialListEmptyState() {
  return (
    <Container>
      <IconCircle>
        <PatientListsIcon width={32} height={32} color={colors.aiPurple} />
      </IconCircle>
      <Text>No patients have been added to your denial list yet.</Text>
    </Container>
  );
}

const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${colors.aiPurple10};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 24px;
`;

const Text = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${colors.black75};
  text-align: center;
  margin: 0;
  max-width: 640px;
`;
